import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_SUPPLY_CHAIN_INFORMATIONS_KEY } from '@/keys';
import type { SupplyChainInformation } from '@/types/core/purchase-order/supply-chain-information';

type CreateSupplyChainInformationVariables = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  actorId: number;
  actorTypeId: number;
  token?: string;
};

async function createSupplyChainInformation({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  token,
  ...payload
}: CreateSupplyChainInformationVariables): Promise<SupplyChainInformation> {
  const response = await api.post<SupplyChainInformation>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/supply-chain-informations`,
    payload,
    {
      params: token ? { token } : undefined,
    },
  );

  return response.data;
}

export function useCreateSupplyChainInformation(): UseMutationResult<
  SupplyChainInformation,
  Error,
  CreateSupplyChainInformationVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSupplyChainInformation,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_SUPPLY_CHAIN_INFORMATIONS_KEY,
          variables.productionDeclarationId,
          variables.materialId,
          variables.commodityOriginId,
          variables.token ?? '',
        ],
      });
    },
  });
}
